import { Box, Link } from "@mui/material";
import { IKeyValuePair } from "../../common/models/KeyValuePair";
import useNavigateTo, { NavigateToOptions } from "../../hooks/use-navigate-to/useNavigateTo";
import { NewViewTypeEnum } from "../../common/enums/NewViewTypeEnum";
import { GroupCellRendererParams } from "ag-grid-enterprise";

interface IObjectGroupingCellRendererParams extends GroupCellRendererParams {
    navigationObjects: IKeyValuePair<string, string>[];
}

export default function ObjectGroupingCellRenderer(params: IObjectGroupingCellRendererParams) {

    const navigateTo = useNavigateTo();
    const href = params.navigationObjects?.find(o => o.Key === params.node.key)?.Value;

    function onNavigate(shiftKey: boolean, ctrlKey: boolean) {

        if (href) {
            
            let options: NavigateToOptions | undefined;

            if (shiftKey || ctrlKey) {
                options = {
                    newViewType: shiftKey ? NewViewTypeEnum.NewWindow : NewViewTypeEnum.NewTab
                }
            }

            navigateTo(href, options)
        }
    }

    return(
        <>
        {
            href ? 
            <Link
                sx={{
                    color: "text.primary",
                    '&:hover': {
                        cursor: 'pointer'
                    }
                }}
                onClick={(ev) => onNavigate(ev.shiftKey, ev.ctrlKey)}
            >
                    {params.value}
            </Link> :
            <Box style={{whiteSpace: 'normal'}}>{params.value}</Box>
        }
        </>

    )
}
